/*
 * @Author: panweikang
 * @Date: 2024-01-04 15:23:35
 * @LastEditTime: 2024-01-17 13:02:44
 * @Description:
 */
import './about.scss'
import logo from '../../static/report/logo.png'
import aboutPng from '../../static/about/about.png'
import { Avatar, List, Space, Image, Button } from 'antd-mobile'
import { useNavigate } from 'react-router-dom'
import MHead from '../../components/MHead/index'

let About = () => {
  // document.title = '关于瑞莱博'
  document.title = '瑞莱博2023年物流地产年度报告'
  let navigate = useNavigate()
  let goHome = () => {
    navigate(`/rlb/YearMiddleReport2024/1`)
  }

  return (
    <div className="about">
      <MHead />
      {/* <div className="head">
        <img src={logo} alt="logo" onClick={goHome} />
      </div> */}
      <Image src={aboutPng} fit="fill" width="100%" />
    </div>
  )
}

export default About
